module.exports = __webpack_public_path__ + "static/img/head5.6a80359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head5.png
// module id = iXZ8
// module chunks = 1